import {ValueObject} from '@s-ui/domain'

export default class BreadcrumbValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Array<Object>} breadcrumbs
   * @param {String} breadcrumbs.label
   * @param {String} breadcrumbs.url
   */

  toJSON() {
    return this._breadcrumbs
  }
}
